module.exports = __webpack_public_path__ + "static/media/capricorn.04949a1f.svg";